/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbFormateurTitreGridDto
 */
export interface FcbFormateurTitreGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurTitreGridDto
     */
    idtitreFormateur?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurTitreGridDto
     */
    idformateur?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurTitreGridDto
     */
    idtitre?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbFormateurTitreGridDto
     */
    titre?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbFormateurTitreGridDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbFormateurTitreGridDto
     */
    date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof FcbFormateurTitreGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurTitreGridDto
     */
    idfichier?: number | null;
}

/**
 * Check if a given object implements the FcbFormateurTitreGridDto interface.
 */
export function instanceOfFcbFormateurTitreGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFormateurTitreGridDtoFromJSON(json: any): FcbFormateurTitreGridDto {
    return FcbFormateurTitreGridDtoFromJSONTyped(json, false);
}

export function FcbFormateurTitreGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFormateurTitreGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idtitreFormateur': !exists(json, 'idtitreFormateur') ? undefined : json['idtitreFormateur'],
        'idformateur': !exists(json, 'idformateur') ? undefined : json['idformateur'],
        'idtitre': !exists(json, 'idtitre') ? undefined : json['idtitre'],
        'titre': !exists(json, 'titre') ? undefined : json['titre'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'date': !exists(json, 'date') ? undefined : (json['date'] === null ? null : new Date(json['date'])),
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
    };
}

export function FcbFormateurTitreGridDtoToJSON(value?: FcbFormateurTitreGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idtitreFormateur': value.idtitreFormateur,
        'idformateur': value.idformateur,
        'idtitre': value.idtitre,
        'titre': value.titre,
        'libelle': value.libelle,
        'date': value.date === undefined ? undefined : (value.date === null ? null : value.date.toISOString()),
        'fileName': value.fileName,
        'idfichier': value.idfichier,
    };
}

